import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import ProductModal from './ProductModal';
import { products, mainProduct } from '../data/product';
import './TopProducts.css';

function TopProducts() {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const { addToCart } = useCart();
    const navigate = useNavigate();

    return (
        <>
            <section className="top-products" id="product">
                <div className="products-grid">
                    {products.map((product) => (
                        <div
                            key={product.id}
                            className="product-card"
                            onClick={() => {
                                setSelectedProduct(product);
                                setIsModalOpen(true);
                            }}
                        >
                            <div className="product-image-wrapper">
                                <img src={product.image} alt={product.name} />
                            </div>
                            <div className="product-info-wrapper">
                                <p className="price">{product.price.toFixed(2)} €</p>
                                <button
                                    className="buy-now-btn"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        if (product.id === mainProduct.id) {
                                            navigate('/premium-strap');
                                            return;
                                        }
                                        addToCart({
                                            ...product,
                                            selectedSize: 'N/A',
                                            selectedColor: 'N/A',
                                            quantity: 1
                                        });
                                    }}
                                >
                                    Купи
                                </button>
                                <button
                                    className="view-product-btn"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        setSelectedProduct(product);
                                        setIsModalOpen(true);
                                    }}
                                >
                                    Детайли
                                </button>
                                <h3>{product.name}</h3>
                            </div>
                        </div>
                    ))}
                </div>
            </section>
            <ProductModal
                product={selectedProduct || products[0]}
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
            />
        </>
    );
}

export default TopProducts;

